import styled from 'styled-components';
import { useState } from 'react';
import { useUser } from '../../context/UserContext';
import { useNavigate } from 'react-router-dom';
import ConfirmModal from './ConfirmModal';
import UserService from '../../service/User';
import PageTop from '../components/pageTop/PageTop';
import Menu from '../components/menu/Menu';

const ChangeContactNumber = () => {
  const [newPhone, setNewPhone] = useState('');
  const [isSendSms, setIsSendSms] = useState(false);
  const [confirmNumber, setConfirmNumber] = useState('');
  const [isConfirm, setIsConfirm] = useState(false);
  const [openConfirmModal, setOpenConfirmModal] = useState(false);
  const [openMenu, setOpenMenu] = useState(false);

  const navigate = useNavigate();

  const { user } = useUser();

  const SendSms = async () => {
    try {
      const data = {
        type: 'U',
        loginType: user?.login_type,
        userid: user?.userid,
        tel: newPhone,
      };
      const res = await UserService.SendSms(data);
    } catch (error) {
      console.error('SendSms 함수에서 에러 발생:', error);
    }
  };

  const checkCode = async () => {
    try {
      const data = {
        type: 'U',
        loginType: user?.login_type,
        userid: user?.userid,
        tel: newPhone,
        authCode: confirmNumber,
      };
      const res = await UserService.CheckCode(data);
      if (res.status === 'success') {
        alert('인증되었습니다.');
      }
      setIsConfirm(true);
    } catch (error) {
      alert('인증번호가 일치하지 않습니다.');
    }
  };

  const updatePhone = async () => {
    try {
      const data = {
        department: '',
        position: '',
        tel: newPhone,
      };
      const res = await UserService.updateUserInfo(data);
      setOpenConfirmModal(true);
    } catch (error) {
      console.error('updatePhone 함수에서 에러 발생:', error);
    }
  };

  const handleSendSms = async () => {
    setConfirmNumber('');
    setIsSendSms(true);
    await SendSms();
  };

  const isDisabled = newPhone === '' || confirmNumber === '' || !isConfirm;
  const isSendSmsDisabled = newPhone === '';
  const isConfirmDisabled = confirmNumber === '';

  return (
    <Container>
      <PageTop text="휴대폰번호 변경" setOpenMenu={setOpenMenu} />
      <Inner>
        <ContentBox>
          <Block>
            <div>이름</div>
            <InputBox>
              <Input
                type="text"
                disabled
                placeholder="이름(실명)"
                value={user?.name}
              />
            </InputBox>
          </Block>
          <Block>
            <div>신규 휴대폰 번호</div>
            <BlockRow>
              <InputBox style={{ flex: 1 }}>
                <Input
                  type="tel"
                  placeholder="- 없이 숫자만 입력"
                  value={newPhone}
                  maxLength={11}
                  onChange={(e) => {
                    const value = e.target.value.replace(/[^0-9]/g, '');
                    setNewPhone(value);
                    setIsSendSms(false);
                    setConfirmNumber('');
                    setIsConfirm(false);
                  }}
                />
              </InputBox>
              {isSendSms ? (
                <ResendButton onClick={handleSendSms}>재발송</ResendButton>
              ) : (
                <SendSmsButton
                  disabled={isSendSmsDisabled}
                  onClick={handleSendSms}
                >
                  인증번호 전송
                </SendSmsButton>
              )}
            </BlockRow>
            {isSendSms && (
              <BlockRow>
                <InputBox style={{ flex: 1 }}>
                  <Input
                    type="text"
                    placeholder="인증번호 입력"
                    value={confirmNumber}
                    onChange={(e) => setConfirmNumber(e.target.value)}
                  />
                </InputBox>
                <SendSmsButton disabled={isConfirmDisabled} onClick={checkCode}>
                  확인
                </SendSmsButton>
              </BlockRow>
            )}
          </Block>
        </ContentBox>
        <ButtonBox>
          <CancelButton
            onClick={() => {
              navigate('/mypage?tab=myinfo');
            }}
          >
            취소
          </CancelButton>
          <ApplyButton disabled={isDisabled} onClick={updatePhone}>
            휴대폰번호 변경
          </ApplyButton>
        </ButtonBox>
      </Inner>
      {openConfirmModal && (
        <ConfirmModal
          type="confirm"
          title="휴대폰번호 변경 완료"
          text="휴대폰번호 변경이 완료되었습니다."
          buttonText="확인"
          onClick={() => {
            setOpenConfirmModal(false);
            navigate('/mypage');
            sessionStorage.setItem('mypageTab', 'myinfo');
          }}
        />
      )}
      {openMenu && <Menu page="changeContact" setOpenMenu={setOpenMenu} />}
    </Container>
  );
};
export default ChangeContactNumber;

const Container = styled.div`
  max-width: 900px;
  min-height: 100vh;
  margin: 0 auto;
  box-shadow: 0 0 20px hsla(0, 0%, 51%, 0.15);
  position: relative;
  font-family: Spoqa Han Sans Neo;
  display: flex;
  flex-direction: column;
`;

const Inner = styled.div`
  width: 100%;
  padding: 24px 16px 40px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-grow: 1;
`;
const ContentBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const Block = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
  font-family: Spoqa Han Sans Neo;
  font-size: 16px;
  font-weight: 700;
  color: #222;
`;

const ButtonBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 8px;
`;
const CancelButton = styled.button`
  width: 108px;
  height: 50px;
  border-radius: 8px;
  background: rgba(112, 115, 124, 0.08);
  color: #616161;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: Spoqa Han Sans Neo;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  border: none;
`;

const ApplyButton = styled.button`
  flex: 1;
  height: 50px;
  border-radius: 8px;
  background: ${({ disabled }) =>
    disabled ? 'rgba(112, 115, 124, 0.08)' : '#008AFF'};
  color: ${({ disabled }) => (disabled ? 'rgba(55, 56, 60, 0.16)' : '#fff')};
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: Spoqa Han Sans Neo;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  border: none;
`;

const BlockRow = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 12px;
`;

const InputBox = styled.div`
  width: 100%;
  height: 50px;
  border-radius: 8px;
  background: #f5f7fa;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px;
`;
const Input = styled.input`
  border: none;
  background: none;
  flex: 1;
  outline: none;
`;

const SendSmsButton = styled.button`
  width: 118px;
  height: 50px;
  border-radius: 8px;
  background: ${({ disabled }) => (disabled ? '#f7f7f8' : '#008AFF')};
  color: ${({ disabled }) => (disabled ? 'rgba(55, 56, 60, 0.16)' : '#fff')};
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: Spoqa Han Sans Neo;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  border: none;
`;
const ResendButton = styled.button`
  width: 118px;
  height: 50px;
  border-radius: 8px;
  background: white;
  color: #008aff;
  border: 1px solid #008aff;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: Spoqa Han Sans Neo;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  border: none;
`;
